<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119 no-padd">
    <div class="col-md-12 no-padd">
      <div id="row" class="container pb-20">
        <div class="row">
          <div class="col-md-12">
            <div class="bg-yellow-gradient text-shadow mt-32">
              <h1 class="py-2 m-6 mt-16 mb-16 a-font-style textColor black">Nome da Marca</h1>
            </div>
          </div>
          <div class="row text-center col-12">
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mt-3 mb-1 card-expand">
              <div class="card card-w-h shadow-card">
                <div class="">
                  <img src="../../assets/images/bulgari.jpg" class="card-img-top backgroundColor img-h white base img-fluid rounded-0" alt="...">
                </div>
                <div class="card-body list-inline">
                  <h2 class="card-text text-white card-text-limit font-italic">Frederique Constant</h2>
                  <h2 class="card-text text-white card-text-limit mt-4 font-italic">Navitimer 1959 Limited Edition</h2>
                  <div class="d-flex justify-content-around align-items-baseline -bottom-2">
                    <p class="card-text list-inline-item textColor new-orleans base position-relative">Sob consulta €</p>
                    <a href="#" class="btn btn-grad list-inline-item position-relative">Ver Mais</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-20">
          <a href="#" class="btn btn-yellow-grad px-16 mr-6">Ver Mais</a>
        </div>
      </div>
    </div>
  </section>
</div>